/* ONNARA – tiroir panier : « Complète ta routine » (carrousel + ajout direct), bouton « Finaliser ma commande » et réassurance.
   La livraison datée s'affiche uniquement sous l'encadré de réassurance des fiches produit. */
(function () {
  var CUTOFF = 14; /* heure limite (Paris) pour une expédition le jour même, du lundi au vendredi */
  var ORDER = ['glow-pure-scrub-gommage-eclat','creme-corps-eclat','lait-corps-eclat-c','gel-douche-eclat-g','huile-revelation-g','huile-de-douche-intense','duo-corps-peau-douce','duo-corps-eclat-quotidien','duo-corps-intense-peau-lisse','duo-corps-intense-nutrition','duo-corps-intense-hydratation','duo-corps-nutrition-glow','duo-corps-grain-de-peau-confort','routine-corps-eclat','rituel-corps-intense'];
  var JOURS = ['dim.','lun.','mar.','mer.','jeu.','ven.','sam.'];
  var MOIS = ['janv.','févr.','mars','avr.','mai','juin','juil.','août','sept.','oct.','nov.','déc.'];

  var css = '' +
  '#CartDrawer-CartItems{min-width:0;max-width:100%}' +
  '.onr-dl{min-width:0;box-sizing:border-box;margin:14px 16px 6px;padding:14px 14px 12px;border:1.5px solid #E4DAEE;border-radius:16px;background:#fff;font-family:Montserrat,sans-serif;color:#1C1C1C}' +
  '.onr-dl__top{display:flex;align-items:center;gap:10px;font-size:13.5px;line-height:1.35;padding:8px 12px;border-radius:12px;background:#F6F1FA}' +
  '.onr-dl__dot{flex:0 0 10px;width:10px;height:10px;border-radius:50%;background:#9E83B8;box-shadow:0 0 0 4px #E4DAEE;animation:onrPulse 1.6s ease-in-out infinite}' +
  '@keyframes onrPulse{50%{box-shadow:0 0 0 7px rgba(158,131,184,.18)}}' +
  '.onr-dl__top b{color:#9E83B8}' +
  '.onr-dl__steps{display:flex;justify-content:space-between;position:relative;margin:14px 4px 4px}' +
  '.onr-dl__steps:before{content:"";position:absolute;left:16%;right:16%;top:19px;height:2px;background:#E4DAEE}' +
  '.onr-dl__st{position:relative;flex:1;text-align:center}' +
  '.onr-dl__ic{width:38px;height:38px;margin:0 auto 6px;border-radius:50%;background:#9E83B8;color:#fff;display:flex;align-items:center;justify-content:center}' +
  '.onr-dl__ic svg{width:18px;height:18px}' +
  '.onr-dl__lb{font-size:12px;opacity:.7}' +
  '.onr-dl__dt{font-size:13px;font-weight:700;margin-top:1px}' +
  '.onr-dl__idf{margin-top:10px;font-size:12px;text-align:center;opacity:.75}' +
  '.onr-dl__idf b{opacity:1}' +
  '.product__info-container .onr-dl,.product__info-wrapper .onr-dl{margin:12px 0 4px}' +
  '.onr-up{min-width:0;max-width:100%;width:100%;overflow:hidden;box-sizing:border-box;margin:10px 0 6px;padding:16px 0 14px;background:#F6F1FA;font-family:Montserrat,sans-serif;color:#1C1C1C}' +
  '.onr-up__hd{display:flex;align-items:center;justify-content:space-between;padding:0 16px 12px}' +
  '.onr-up__t{margin:0;font-size:13px;font-weight:700;letter-spacing:.08em;text-transform:uppercase}' +
  '.onr-up__nav{display:flex;gap:8px}' +
  '.onr-up__nav button{width:32px;height:32px;border-radius:50%;border:1px solid #CCBBDB;background:#fff;color:#1C1C1C;font-size:15px;line-height:1;cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0}' +
  '.onr-up__row{min-width:0;max-width:100%;display:flex;gap:10px;overflow-x:auto;scroll-snap-type:x mandatory;scrollbar-width:none;padding:0 16px 2px;scroll-padding:0 16px;-webkit-overflow-scrolling:touch}' +
  '.onr-up__row::-webkit-scrollbar{display:none}' +
  '.onr-up__c{flex:0 0 38%;max-width:150px;scroll-snap-align:start;display:flex;flex-direction:column;gap:6px;padding:8px;background:#fff;border-radius:14px;border:1px solid #EFE8F5;box-sizing:border-box}' +
  '.onr-up__img{width:100%;aspect-ratio:1/1;border-radius:10px;overflow:hidden;background:#F7F4F0;display:block}' +
  '.onr-up__img img{width:100%;height:100%;object-fit:cover;display:block}' +
  '.onr-up__b{flex:1;min-width:0;display:flex;flex-direction:column;gap:3px}' +
  '.onr-up__n{min-height:2.5em;font-size:12px;font-weight:600;line-height:1.25;color:#1C1C1C;text-decoration:none;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}' +
  '.onr-up__p{font-size:12.5px;font-weight:700}.onr-up__p s{font-weight:400;font-size:11px;color:#D93636;margin-left:4px}' +
  '.onr-up__add{align-self:stretch;margin-top:auto;border:1.5px solid #1C1C1C;background:#fff;color:#1C1C1C;border-radius:50px;padding:7px 6px;font:600 11px Montserrat,sans-serif;letter-spacing:.06em;text-transform:uppercase;cursor:pointer}' +
  '.onr-up__add:hover{background:#1C1C1C;color:#fff}.onr-up__add[disabled]{opacity:.5;cursor:default}' +
  '.onr-ck{list-style:none;margin:10px 0 0;padding:0;display:flex;justify-content:center;flex-wrap:wrap;gap:4px 14px;font:500 11.5px Montserrat,sans-serif;color:#1C1C1C}' +
  '.onr-ck li{display:flex;align-items:center;gap:5px}.onr-ck svg{width:14px;height:14px;stroke:#758976;fill:none;stroke-width:2.2}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  var ICON = {
    bag: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 7h12l1 13H5L6 7z"/><path d="M9 7a3 3 0 0 1 6 0"/></svg>',
    box: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 8l-9-5-9 5 9 5 9-5z"/><path d="M3 8v8l9 5 9-5V8"/><path d="M12 13v8"/></svg>',
    home: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 11l9-7 9 7"/><path d="M5 10v10h14V10"/><path d="M10 20v-5h4v5"/></svg>'
  };

  /* ---------- Dates de livraison (heure de Paris) ---------- */
  function parisNow() {
    try {
      var p = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hour12: false }).formatToParts(new Date());
      var o = {}; p.forEach(function (x) { o[x.type] = x.value; });
      return { d: new Date(+o.year, +o.month - 1, +o.day, 12), h: +o.hour % 24 };
    } catch (e) { var n = new Date(); return { d: new Date(n.getFullYear(), n.getMonth(), n.getDate(), 12), h: n.getHours() }; }
  }
  function addDays(d, n) { var x = new Date(d); x.setDate(x.getDate() + n); return x; }
  function nextShipDay(d) { while (d.getDay() === 0 || d.getDay() === 6) d = addDays(d, 1); return d; }
  function addDeliveryDays(d, n) { while (n > 0) { d = addDays(d, 1); if (d.getDay() !== 0) n--; } return d; }
  function fmtDay(d) { return JOURS[d.getDay()] + ' ' + d.getDate(); }
  function deliveryHTML() {
    var now = parisNow(), today = now.d, wd = today.getDay();
    var sameDay = wd >= 1 && wd <= 5 && now.h < CUTOFF;
    var ship = sameDay ? today : nextShipDay(addDays(today, 1));
    var d1 = addDeliveryDays(ship, 1), d2 = addDeliveryDays(ship, 3);
    var diff = Math.round((ship - today) / 864e5);
    var shipTxt = diff === 1 ? 'demain' : ['dimanche','lundi','mardi','mercredi','jeudi','vendredi','samedi'][ship.getDay()];
    var top = sameDay
      ? 'Commande avant ' + CUTOFF + 'h, expédiée <b>aujourd’hui</b>'
      : 'Commande maintenant, expédiée <b>' + shipTxt + '</b>';
    var range = d1.getMonth() === d2.getMonth() ? d1.getDate() + ' – ' + d2.getDate() + ' ' + MOIS[d2.getMonth()] : d1.getDate() + ' ' + MOIS[d1.getMonth()] + ' – ' + d2.getDate() + ' ' + MOIS[d2.getMonth()];
    return '<div class="onr-dl__top"><span class="onr-dl__dot"></span><span>' + top + '</span></div>' +
      '<div class="onr-dl__steps">' +
        '<div class="onr-dl__st"><div class="onr-dl__ic">' + ICON.bag + '</div><div class="onr-dl__lb">Commandé</div><div class="onr-dl__dt">Aujourd’hui</div></div>' +
        '<div class="onr-dl__st"><div class="onr-dl__ic">' + ICON.box + '</div><div class="onr-dl__lb">Expédié</div><div class="onr-dl__dt">' + (diff === 0 ? 'Aujourd’hui' : fmtDay(ship)) + '</div></div>' +
        '<div class="onr-dl__st"><div class="onr-dl__ic">' + ICON.home + '</div><div class="onr-dl__lb">Livré</div><div class="onr-dl__dt">' + range + '</div></div>' +
      '</div>' +
      '<div class="onr-dl__idf">En Île-de-France, livraison en <b>24 à 48 h</b></div>';
  }
  function makeDelivery() { var b = document.createElement('div'); b.className = 'onr-dl'; b.innerHTML = deliveryHTML(); return b; }

  /* ---------- Données produits (déjà présentes pour Nara) ---------- */
  var DATA = null;
  function data() {
    if (DATA) return DATA;
    try { DATA = JSON.parse(document.getElementById('onr-nara-data').textContent); } catch (e) { DATA = {}; }
    return DATA;
  }
  function nice(t) { t = (t || '').replace(/ – glow pure scrub/i, ''); return t.charAt(0).toUpperCase() + t.slice(1).toLowerCase(); }

  /* ---------- Carrousel « Complète ta routine » ---------- */
  var cartHandles = [];
  function upsellHTML() {
    var D = data(), cards = '';
    ORDER.forEach(function (h) {
      var p = D[h];
      if (!p || !p.available || cartHandles.indexOf(h) > -1) return;
      cards += '<div class="onr-up__c"><a class="onr-up__img" href="' + p.url + '"><img src="' + p.img + '" alt="" loading="lazy" width="150" height="150"></a>' +
        '<div class="onr-up__b"><a class="onr-up__n" href="' + p.url + '">' + nice(p.title) + '</a>' +
        '<span class="onr-up__p">' + p.price + (p.compare ? '<s>' + p.compare + '</s>' : '') + '</span>' +
        '<button type="button" class="onr-up__add" data-onr-add="' + p.id + '">Ajouter</button></div></div>';
    });
    if (!cards) return '';
    return '<div class="onr-up__hd"><p class="onr-up__t">Complète ta routine</p><div class="onr-up__nav"><button type="button" data-onr-nav="-1" aria-label="Précédent">‹</button><button type="button" data-onr-nav="1" aria-label="Suivant">›</button></div></div><div class="onr-up__row">' + cards + '</div>';
  }

  /* ---------- Bouton « Finaliser ma commande » + 3 points de réassurance ---------- */
  var CK = '<li><svg viewBox="0 0 24 24"><rect x="5" y="11" width="14" height="10" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>Paiement sécurisé</li>' +
    '<li><svg viewBox="0 0 24 24"><path d="M3 12a9 9 0 1 0 3-6.7"/><path d="M3 4v5h5"/></svg>Retours sous 30 jours</li>' +
    '<li><svg viewBox="0 0 24 24"><path d="M3 7h11v9H3z"/><path d="M14 10h4l3 3v3h-7"/><circle cx="7" cy="18" r="2"/><circle cx="17" cy="18" r="2"/></svg>Expédiée sous 24 à 48 h</li>';
  function checkout(root) {
    var b = root.querySelector('#CartDrawer-Checkout, button[name="checkout"], #checkout');
    if (!b) return;
    if (b.getAttribute('data-onr') !== '1') {
      var done = false;
      b.childNodes.forEach(function (n) { if (!done && n.nodeType === 3 && n.textContent.trim()) { n.textContent = ' Finaliser ma commande '; done = true; } });
      if (!done) { var sp = b.querySelector('span'); if (sp && !sp.children.length) sp.textContent = 'Finaliser ma commande'; }
      b.setAttribute('data-onr', '1');
    }
    var box = b.closest('.cart__ctas') || b.parentNode;
    if (!box.parentNode.querySelector('.onr-ck')) { var ul = document.createElement('ul'); ul.className = 'onr-ck'; ul.innerHTML = CK; box.insertAdjacentElement('afterend', ul); }
  }

  function placeDrawer() {
    var cd = document.querySelector('cart-drawer');
    if (!cd) return;
    var wrap = cd.querySelector('#CartDrawer-CartItems .drawer__cart-items-wrapper') || cd.querySelector('#CartDrawer-CartItems');
    if (!wrap || cd.querySelector('.drawer__inner.is-empty')) return;
    var host = wrap.parentNode;
    var old = host.querySelector(':scope > .onr-dl'); if (old) old.remove();
    checkout(cd);
    var up = host.querySelector(':scope > .onr-up');
    var html = upsellHTML();
    if (!html) { if (up) up.remove(); return; }
    if (!up) { up = document.createElement('div'); up.className = 'onr-up'; wrap.insertAdjacentElement('afterend', up); }
    if (up.getAttribute('data-k') !== cartHandles.join(',')) { up.innerHTML = html; up.setAttribute('data-k', cartHandles.join(',')); }
  }

  var busy = false, timer;
  function refresh() {
    if (busy) return; busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
      .then(function (c) { cartHandles = (c.items || []).map(function (i) { return i.handle; }); placeDrawer(); })
      .catch(function () { placeDrawer(); }).finally(function () { busy = false; });
  }
  function soon() { clearTimeout(timer); timer = setTimeout(refresh, 200); }

  document.addEventListener('click', function (e) {
    var nav = e.target.closest && e.target.closest('[data-onr-nav]');
    if (nav) {
      var row = nav.closest('.onr-up').querySelector('.onr-up__row');
      var card = row.querySelector('.onr-up__c');
      row.scrollBy({ left: (+nav.getAttribute('data-onr-nav')) * ((card ? card.offsetWidth : 140) + 10), behavior: 'smooth' });
      return;
    }
    var add = e.target.closest && e.target.closest('[data-onr-add]');
    if (!add) return;
    e.preventDefault();
    add.disabled = true; add.textContent = 'Ajout…';
    var cd = document.querySelector('cart-drawer');
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: +add.getAttribute('data-onr-add'), quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble', sections_url: location.pathname })
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status || !res.sections) { add.disabled = false; add.textContent = 'Ajouter'; return; }
      if (cd && cd.renderContents) cd.renderContents(res); else location.href = '/cart';
      soon();
    }).catch(function () { add.disabled = false; add.textContent = 'Ajouter'; });
  });

  function productPage() {
    if (!document.getElementById('onr-trust-tpl')) return;
    var tries = 0;
    (function wait() {
      var trust = document.querySelector('.onr-trust');
      if (trust) { if (!document.querySelector('.onr-trust + .onr-dl')) trust.insertAdjacentElement('afterend', makeDelivery()); return; }
      if (++tries < 40) setTimeout(wait, 150);
    })();
  }

  function init() {
    var cd = document.querySelector('cart-drawer');
    if (cd) new MutationObserver(function (m) {
      for (var i = 0; i < m.length; i++) { var n = m[i].target; if (!(n.closest && n.closest('.onr-up, .onr-dl, .onr-fs, .onr-ck'))) { soon(); return; } }
    }).observe(cd, { childList: true, subtree: true });
    refresh();
    productPage();
    var cp = document.querySelector('#main-cart-footer, .cart__footer');
    if (cp) checkout(cp);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();